import React, { createContext } from "react";
const UserSettingsContext = createContext(null);
function UserSettingsProvider({ storage, children }) {
  return /* @__PURE__ */ React.createElement(UserSettingsContext.Provider, { value: { storage } }, children);
}
export {
  UserSettingsContext,
  UserSettingsProvider
};
//# sourceMappingURL=UserSettingsProvider.js.map
